export const PAGO_MOVIL_ACTIONS = {
  REFERENCE: 'REFERENCE',
  BANK: 'BANK',
  DATE: 'DATE',
  DNITYPE: 'DNITYPE',
  DNI: 'DNI',
  PHONE: 'PHONE',
  PM_AMOUNT: 'PM_AMOUNT',
} as const;

export const TDC_ACTIONS = {
  CARDNAME: 'CARDNAME',
  DNI: 'DNI',
  DNITYPE: 'DNITYPE',
  TYPETDC: 'TYPETDC',
  CARDNUMBER: 'CARDNUMBER',
  EXPIRATIONDATE: 'EXPIRATIONDATE',
  CVC: 'CVC',
} as const;

export const formatCardNumber = (value: string) => {
  // Remove any character that is not a number
  const cleaned = value.replace(/\D+/g, '');
  // Formated with space every 4 digits
  const formatted = cleaned.replace(/(\d{4})(?=\d)/g, '$1 ');
  return formatted;
};

export const formatDniNumber = (value: string) => {
  // Remove any character that is not a number
  const cleaned = value.replace(/\D+/g, '');
  // Formated with dot every 3 digits
  const formatted = cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return formatted;
};

export function formatPhoneNumber(value) {
  // Elimina todos los caracteres que no sean dígitos
  const cleanedValue = value.replace(/\D/g, '');
  // Aplica el formato: 4 dígitos, espacio, 3 dígitos, espacio, 4 dígitos
  const formattedValue = cleanedValue.replace(
    /^(\d{4})(\d{3})(\d{2})(\d{2})$/,
    '$1-$2.$3.$4'
  );

  return formattedValue;
}
